<template>
    <el-dialog :title="title" :visible.sync="dialogVisible" @close="handleClose">
        <el-descriptions :column="1" border>
            <el-descriptions-item v-for="(item, index) in items" :label="item.label" :key="index">
                <p v-if="item.type == 'text'" >{{ item.value }}</p>
                <div v-else-if="item.type == 'image'" class="demo-image">
                    <div v-for="image in item.value" :key="image.id" class="block">
                    <span class="demonstration">{{ image.name }}</span>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="image.url"
                        :zoom-rate="1.2"
                        :preview-src-list="image.urls"
                        :initial-index="0"
                        fit="cover"
                        />
                    </div>
                </div>
            </el-descriptions-item>
        </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ cancelButtonText }}</el-button>
        <el-button type="primary" @click="dialogVisible = false">{{ confirmButtonText }}</el-button>
      </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "Dialog",
        props: ["dialogData", "title"],
        data() {
            return {
                dialogVisible : false,
                confirmButtonText: window.$t('mis.feedback.modal.confirm'),
                cancelButtonText: window.$t('mis.feedback.modal.close'),
            }
        },
        computed: {
            items: {
                get() {
                    return JSON.parse(JSON.stringify(this.dialogData));
                }
            }
        },
        methods: {
            show() {
                this.dialogVisible = true;
            },
            handleClose() {
                this.dialogVisible = false;
            }
        }
    }
</script>

<style scoped>
.demo-image .block {
  padding: 30px 0;
  text-align: center;
  border-right: solid 1px var(--el-border-color);
  display: inline-block;
  width: 33%;
  box-sizing: border-box;
  vertical-align: top;
}
.demo-image .block:last-child {
  border-right: none;
}
.demo-image .demonstration {
  display: block;
  color: var(--el-text-color-secondary);
  font-size: 14px;
  margin-bottom: 20px;
}
</style>